import { Helper } from "../util/helper.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { FAIcon } from "./faIcon.js";
import React from "react";
export class ColorPicker extends React.Component<ColorPickerProps, any>{
    private colorPickerRef: any;
    private colorPicker: kendo.ui.ColorPicker;
    private value: any;
    private disabled = true;
    private resettable: boolean = false;
    private random: boolean = false;


    constructor(props: ColorPickerProps) {
        super(props)
        this.resettable = Helper.getValueOrDefault(props.field.resettable, false);
        this.random = Helper.getValueOrDefault(props.field.random, false);
    }

    componentWillUnmount() {
        //this._colorPicker.destroy();
    }

    componentDidMount() {
        this.disabled = this.props.disabled || false;
        this.value = this.props.value === "" ? null : this.props.value;
        this.colorPicker = $(this.colorPickerRef).kendoColorPicker({
            value: this.value,
            change: (ev) => {
                this.value = ev.sender.value();
                console.log(ev.sender.value());
                this.props.onChange(this.props.field, ev.sender.value(), null)
            },
            buttons: false,
            preview: true,
            opacity: this.props.field.opacity
        }).data("kendoColorPicker");
        this.colorPicker.enable(!this.disabled);
    }

    componentDidUpdate(prevProps, prevState) {
        this.colorPicker.value(this.props.value === "" ? null : this.props.value);

        const isDisabled = this.props.disabled || false;
        if (this.disabled !== isDisabled) {
            this.disabled = isDisabled;
            this.colorPicker.enable(!this.disabled);
        }
        if (this.value !== (this.props.value === "" ? null : this.props.value)) {
            this.value = this.props.value === "" ? null : this.props.value;
            this.colorPicker.value(this.value);
        }
    }

    private createResetButton = () => {
        return (
            <div data-role="button" key={kendo.guid()} onClick={this.resetColor}>
                <FAIcon name={"trash-alt"} attributes={["lg"]} />
            </div>
        );
    }

    private resetColor = () => {
        this.value = null;
        this.props.onChange(this.props.field, null, null);
        this.setState({});
    }

    private createRandomButton = () => {
        return (
            <div data-role="button" key={kendo.guid()} onClick={this.createRandomColor}>
                <FAIcon name={"random"} attributes={["lg"]} />
            </div>
        );
    }

    private createRandomColor = () => {
        const getRandom = () => {
            let result = Math.floor(Math.random() * 255).toString(16);
            if (result.length == 1) {
                result = "0" + result;
            }
            return result;
        }
        this.value = `#${getRandom()}${getRandom()}${getRandom()}${this.props.field.opacity ? "ff" : ""}`;
        this.props.onChange(this.props.field, this.value, null);
        this.setState({});
    }

    render() {
        const colorPicker = (<input ref={(r) => this.colorPickerRef = r} name={this.props.field.model} required={this.props.required} data-label={this.props.field.name} />);
        const resetButton = (!this.props.disabled && this.resettable && (Helper.hasValue(this.value))) ? this.createResetButton() : null;
        const randomButton = !this.props.disabled && this.random ? this.createRandomButton() : null;
        return (
            <div className="is-color-picker">
                {colorPicker}
                {resetButton}
                {randomButton}
            </div>
        );
    }
}
export interface ColorPickerProps extends BaseComponentProps {
    field: ColorPickerField
}

interface ColorPickerField extends BaseField {
    resettable?: boolean;
    random?: boolean;
    opacity?: boolean
}